import Selection from "./selection";

class Highlight extends Selection {
    showTooltip;

    constructor(props) {
        super(props);
        this.showTooltip = !isNullOrUndefined(props.showTooltip) ? props.showTooltip : true;
    }

    async execute({training}) {
        for (let i = 0; i < this.models.length; i++) {
            let model = this.models[i];
            this.models[i] = training.resources[model] ? training.resources[model].name : model;
        }

        performHighlight(this);
    }

}

export default Highlight;
